import client from './client';
import type { Promocode, PromocodeResult, CreatePromocodeData } from '../types/promocode';

export async function applyPromocode(code: string): Promise<PromocodeResult> {
  const { data } = await client.post('/promocodes/apply', { code });
  return data;
}

// Admin endpoints

export async function getPromocodes(): Promise<Promocode[]> {
  const { data } = await client.get('/admin/promocodes');
  return data || [];
}

export async function createPromocode(payload: CreatePromocodeData): Promise<Promocode> {
  const { data } = await client.post('/admin/promocodes', payload);
  return data;
}

export async function updatePromocode(
  id: string,
  payload: Partial<CreatePromocodeData & { isActive: boolean }>
): Promise<Promocode> {
  const { data } = await client.patch(`/admin/promocodes/${id}`, payload);
  return data;
}
